import { ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { fromEvent } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
@Component({
  selector: 'axis-scroll2tb,[axis-scroll2tb]',
  templateUrl: './scroll2tb.component.html'
})
export class Scroll2tbComponent implements OnInit, OnDestroy {
  /*
  * @howToUse: default offset from top: <app-scroll2tb></app-scroll2tb>
  *            custom offset from top:  <app-scroll2tb [offsetTop]="50"></app-scroll2tb>
  */

  @Input() offset = 0; // scrollToElem adjustment above or below the id
  @Input() offsetTop = 100; // how many pixels to scroll down until button appears (default is here)
  @Input() scrollBottom = true;
  @Input() scrollToElem = '';
  @Input() scrollParent = false;
  @Output() scrollEvent = new EventEmitter();

  public scroll2tbActive = false;
  private alive = true;

  constructor(private _cd: ChangeDetectorRef, @Inject(DOCUMENT) private _document: any) { }

  ngOnInit() {
    if (window !== window.parent) {
      fromEvent(window.parent, 'scroll').pipe(takeWhile(x => this.alive)).subscribe(e => {
        this.scrollParentToTopBottom(e);
      });
    }
  }

  ngOnDestroy() {
    this.alive = false;
    if (this._cd) {
      this._cd.detach();
    }
  }

  scrollParentToTopBottom(event) {
    if (window.parent.pageYOffset >= this.offsetTop) {
      this.scroll2tbActive = true;
    } else {
      this.scroll2tbActive = false;
    }
    this._cd.detectChanges();
  }

  @HostListener('window:scroll', ['$event'])
  scrollToTopBottom(event) {
    if (window.pageYOffset >= this.offsetTop) {
      this.scroll2tbActive = true;
    } else {
      this.scroll2tbActive = false;
    }
  }

  scrollToBottom(): void {
    const focusable = this._document.body.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let lastFocusable: HTMLElement;
    const length = focusable.length;
    for (let i = length - 1; i >= 0; i--) {
      const element = focusable[i];
      if (element['tabIndex'] !== -1 && !element['disabled']
        && !element.classList.contains('axis-scroll2tb-bottom')
        && !element.classList.contains('axis-scroll2tb-top')) {
        const isVisisble = this.isVisibleInDOM(element);
        if (isVisisble) {
          lastFocusable = element as HTMLElement;
          break;
        }
      }
    }
    if (lastFocusable) {
      lastFocusable.focus(); // focus on the last element.
    } else {
      if (this.scrollParent) {
        window.parent.scrollTo(0, parent.document.body.scrollHeight);
      } else {
        window.scrollTo(0, this._document.body.scrollHeight);
      }
    }
    this.scrollEvent.emit({ scrollType: 'bottom' });
  }

  scrollToTop(): void {
    const focusable = this._document.body.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let firstFocusable: HTMLElement;
    const length = focusable.length;
    for (let i = 0; i < length; i++) {
      const element = focusable[i];
      if (element['tabIndex'] !== -1 && !element['disabled']) {
        const isVisisble = this.isVisibleInDOM(element);
        if (isVisisble) {
          firstFocusable = element as HTMLElement;
          break;
        }
      }
    }
    if (firstFocusable) {
      firstFocusable.focus(); // focus on the first element.
    } else {
      if (this.scrollParent) {
        window.parent.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
    }
    this.scrollEvent.emit({ scrollType: 'top' });
  }

  isVisibleInDOM(element: any): boolean {
    while (element && element.offsetParent && element.parentNode && element.parentNode.tagName !== 'BODY') {
      element = element.parentNode;
    }
    return !!element.offsetParent;
  }

  @HostListener('click', ['$event'])
  navigate(event) {
    const elem = this._document.getElementById(this.scrollToElem);
    event.preventDefault();
    setTimeout(() => {
      if (elem) {
        this.fnScrollToElem(elem);
      } else {
        const element = this._document.getElementById(this.scrollToElem);
        if (element) {
          this.fnScrollToElem(element);
        }
      }
    }, 0);
  }

  fnScrollToElem(elem: HTMLElement): void {
    const targetTop = elem.getBoundingClientRect().top + window.pageYOffset - this.offset;
    const supportsNativeSmoothScroll = 'scrollBehavior' in this._document.documentElement.style;
    if (supportsNativeSmoothScroll) {
      window.scrollTo({left: 0, top: targetTop, behavior: 'smooth'});
    } else {
      window.scrollTo(0, targetTop);
    }
  }
}
